/* eslint-disable no-nested-ternary */
import styled from 'styled-components';
import Select from 'react-select';

export const Wrapper = styled.div`
  margin-bottom: 16px;
  span.select-error {
    display: flex;
    align-items: center;
    margin-top: var(--flora--space-1);
    color: var(--flora--colors-medium-light-1);
    font-family: var(--flora--fonts-secondary);
    font-size: var(--flora--fontSizes-sm);
    height: 16px;
    & svg {
      margin-right: var(--flora--space-1);
      height: 16px;
    }
  }
`;

export const InputLabel = styled.label<{
  isFloating?: boolean;
  isFocused?: boolean;
  hasValue?: boolean;
}>`
  left: 16px;
  pointer-events: none;
  position: absolute;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
  top: ${props => (props.isFloating ? `12px` : `23px`)};
  font-size: ${props => (props.isFloating ? `0.75rem` : `1rem`)};
  color: ${props =>
    props.isFocused && !props.hasValue
      ? 'var(--flora--colors-nonInteractivePredominant)'
      : `var(--flora--colors-nonInteractivePredominant)`};
  span {
    color: ${props =>
      props.hasValue ? props.theme.colors.text : props.theme.colors.error};
  }
  font-weight: 500;
`;

const styleIsFocused = (isFocused: boolean) => {
  return isFocused
    ? `0 0 0 0.3125rem var(--flora--colors-nonPrimaryButtonHover)`
    : '';
};

export const ReactSelectStyled = styled(Select).attrs(({ theme }) => ({
  styles: {
    control: (styles: any, state: any) => ({
      ...styles,
      cursor: 'pointer',
      width: '100%',
      maxWidth: '570px',
      height: '64px',
      fontSize: '14px',
      backgroundColor: 'none',
      borderWidth: state.selectProps.hasError ? '0px' : '1px',
      borderColor: state.isFocused
        ? 'var(--flora--colors-actionableDefault)'
        : 'var(--flora--colors-nonInteractiveOutline)',
      outlineColor: state.isFocused
        ? 'var(--flora--colors-actionableDefault)'
        : '',
      boxShadow: state.selectProps.hasError
        ? `inset 0 0 0 2px ${theme.colors.error}`
        : styleIsFocused(state.isFocused),

      '&:hover': {
        borderColor: state.isFocused
          ? theme.colors.main
          : 'var(--flora--colors-actionableDefault)',
        outlineColor: state.isFocused
          ? theme.colors.main
          : 'var(--flora--colors-actionableDefault)',
        boxShadow: state.isFocused
          ? ''
          : `0 0 0 0.3125rem var(--flora--colors-nonPrimaryButtonHover)`,
      },
    }),
    option: (styles: any) => ({
      ...styles,
      fontSize: '14px',
      paddingLeft: '20px',
    }),
    container: (styles: any) => ({
      ...styles,
      backgroundColor: theme.colors.shape,
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      marginBottom: '-15px',
    }),
    groupHeading: (styles: any) => ({
      ...styles,
      fontSize: '10px',
      color: theme.colors.main,
    }),
  },
}))<{ hasError: boolean }>``;
